import { ebookApi } from '@services/api';

const devApi = ebookApi.injectEndpoints({
  endpoints: (builder) => ({
    registerTestCar: builder.mutation<
      string,
      {stationTracCode: string}
    >({query: (args) => ({
        url: `/dev-tools/register-car/${args.stationTracCode}`,
        method: "POST"
      })
    }),
  }),
});

export const {
  useRegisterTestCarMutation
} = devApi;
